import AsyncBoundary from '../AsyncBoundary';
import LoadingSpinner from '../LoadingSpinner';
import Menu from './Menu';
import { NetworkError } from '@data-client/react';
import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

function ErrorFallback({ error }: { error: NetworkError }) {
  return <>{error.message}</>;
}

function LoadingFallback() {
  return <LoadingSpinner />;
}

interface INavigationProps {
  onClickMenuItem: () => void;
}

function Navigation({ onClickMenuItem }: INavigationProps) {
  return (
    <nav className={classNames([styles.navigation])}>
      <Menu onClickMenuItem={onClickMenuItem} />
    </nav>
  );
}

export default function NavigationWithSuspense({
  onClickMenuItem
}: INavigationProps) {
  return (
    <AsyncBoundary
      errorFallback={ErrorFallback}
      loadingFallback={LoadingFallback}>
      <Navigation onClickMenuItem={onClickMenuItem} />
    </AsyncBoundary>
  );
}
